import { render, staticRenderFns } from "./DossiersList.vue?vue&type=template&id=52016847&"
import script from "./DossiersList.vue?vue&type=script&lang=js&"
export * from "./DossiersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports